import { Component, HostListener, OnInit } from '@angular/core';
import { Course, CustomField } from '@queries/generated';

import { BasePersistentNotification } from '../base-persistent-notification';

export interface FieldsRequiredNotificationMeta {
  customField?: CustomField;
  course?: Course;
  address?: boolean;
  email?: boolean;
  certificationDefault?: boolean;
}

interface Message {
  translationParams: Record<any, string>;
  messageTranslation: string;
}

class RequiredAddressMessage implements Message {
  translationParams: { storefront: string };
  messageTranslation = 'fields-required-notification.required-address-message';

  constructor(storefrontName) {
    this.translationParams = { storefront: storefrontName };
  }
}

class RequiredCustomFieldMessage implements Message {
  translationParams: { storefront: string; field: string };
  messageTranslation = 'fields-required-notification.required-custom-field-message';

  constructor(storefrontName, customField) {
    this.translationParams = {
      storefront: storefrontName,
      field: customField.name
    };
  }
}

class RequiredCustomFieldFromCourseMessage implements Message {
  translationParams: { field: string; course: string };
  messageTranslation = 'fields-required-notification.required-custom-field-from-course-message';

  constructor(customField, course) {
    this.translationParams = {
      field: customField.name,
      course: course.name
    };
  }
}

class RequiredEmailFromCourseMessage implements Message {
  translationParams: { course: string };
  messageTranslation = 'fields-required-notification.required-email-from-course-message';

  constructor(course) {
    this.translationParams = {
      course: course.name
    };
  }
}

class RequiredAddressFromCourseMessage implements Message {
  translationParams: { course: string };
  messageTranslation = 'fields-required-notification.required-address-from-course-message';

  constructor(course) {
    this.translationParams = { course: course.name };
  }
}

class RequiredCertificationDefaultForTrainingManager implements Message {
  translationParams: {};
  messageTranslation = 'fields-required-notification.required-certification-default-for-tm';
}

@Component({
  selector: 'vnm-fields-required-notification',
  templateUrl: './fields-required-notification.component.html',
  styleUrls: ['./fields-required-notification.component.scss']
})
export class FieldsRequiredNotificationComponent extends BasePersistentNotification implements OnInit {
  @HostListener('click') onClick() {
    const { meta } = this.record;
    if (meta.customField) {
      const field = document.querySelector(`[data-custom-field-id="${meta.customField.id}"]`);
      field?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }
  }

  messageInstance: Message;

  ngOnInit() {
    const { meta } = this.record;
    if (meta.address) {
      if (meta.course) {
        this.messageInstance = new RequiredAddressFromCourseMessage(meta.course);
      } else {
        this.messageInstance = new RequiredAddressMessage(this.record.name);
      }
    }
    if (meta.email) {
      this.messageInstance = new RequiredEmailFromCourseMessage(meta.course);
    }
    if (meta.customField) {
      if (meta.course) {
        this.messageInstance = new RequiredCustomFieldFromCourseMessage(meta.customField, meta.course);
      } else {
        this.messageInstance = new RequiredCustomFieldMessage(this.record.name, meta.customField);
      }
    }
    if (meta.certificationDefault) {
      this.messageInstance = new RequiredCertificationDefaultForTrainingManager();
    }
  }

  get messageTranslation() {
    return this.messageInstance.messageTranslation;
  }

  get messageTranslationParams() {
    return this.messageInstance.translationParams;
  }
}
